import useAuth from 'src/hooks/api/useAuth';
import { useCallback, useEffect, useState } from 'react';

type LossReasonsReturnType = Array<{
  value: number;
  label: string;
}>;

export default () => {
  const { fetch: authFetch } = useAuth();
  const [lossReasons, setLossReasons] = useState<LossReasonsReturnType>([]);

  const getLossReasons = useCallback(async () => {
    const queryURL = '/api/stepCommercial/getReasonsOfLoose/{ reasonsOfLoose{ id, wording} }';

    try {
      const resp = await authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });

      const respJson = await resp.json();

      return respJson.data.reasonsOfLoose.map((p) => ({
        value: p.id,
        label: p.wording,
      }));
    } catch (error) {
      console.log('erreur fetch search async:\n%s', error);
      return [];
    }
  }, []);

  useEffect(() => {
    getLossReasons().then(setLossReasons);
  }, []);

  return lossReasons;
};
